import type { ApiFailureAction } from 'modules/global/generic.types';

export const pairTvFailureMessageId = (failureAction: ApiFailureAction): string => {
  // `response` is absent on network / timeout errors, and `data` when the error response
  // carries no body — the auto-generated failure action's payload is the raw Axios error.
  const errorCode = failureAction.payload?.response?.data?.errorCode;
  if (errorCode === 400) {
    return 'page.cameras.pair.invalidCode';
  }

  return 'page.cameras.pair.failure';
};
